import { produce } from 'immer'
import type { State } from '../../typings'

export function clearCustomerProducer(state: State): State {
  return produce(state, (draft) => {
    draft.referralCustomerId = ''
    draft.referralCustomerIdTemp = ''
    draft.referralDiscountCode = ''
    draft.referralDiscountId = ''
    draft.referralDiscountValue = 0
  })
}
